import React from "react"
import { Box } from "@mui/material"
import EuropcarWeekSearchesCard from "Pages/BusinessLogistics/Analytics/Page/@components/Cards/Week"
import EuropcarMonthSearchesCard from "Pages/BusinessLogistics/Analytics/Page/@components/Cards/Month"
import EuropcarDateRangeSearchesCard from "Pages/BusinessLogistics/Analytics/Page/@components/Cards/DateRange"


export default function EuropcarCards() {


	return <Box sx={{ display: 'flex', alignItems: 'stretch', height: '100%', justifyContent: 'center', flexDirection: 'column', gap: 2 }}>
		<EuropcarDateRangeSearchesCard/>
		<EuropcarWeekSearchesCard/>
		<EuropcarMonthSearchesCard/>
	</Box>
}